<!-- Part of the SPARKL educational activity system, Copyright 2020 by Pepper Williams -->
<template><div class="k-collection-plan-edit">
	<div class="d-flex align-center">
		<b class="mr-2">{{type_noun}} Plan Scheme:</b>
		<k-select v-model="collection_plan_select_value" dense outlined background-color="#fff" hide-details
			style="max-width:420px"
			label="" 
			:items="collection_plan_schemes_select_arr" 
		></k-select>
	</div>
	<div v-if="collection_plan_select_value" class="k-collection-plan-edit-options">
		<div v-for="(component, key, i) in collection_plan.cp_scheme.cp_components" :key="key"
		>
			<div v-if="component.type == 'section'" class="d-flex align-start mb-3">
				<b class="mt-5 mr-3 text-right" style="flex:0 0 160px; line-height:20px">{{component.title}}:</b>
				<k-icon class="mr-2" style="margin-top:18px;" color="black">fa-fw {{component.icon}}</k-icon>
				<div class="k-collection-plan-froala-wrapper-wrapper" style="flex:0 0 700px">
					<froala-wrapper :config="editor_config('')" v-model="collection_plan.cpc_text[key]" />
				</div>

			</div>
			<div v-if="component.type == 'link'" class="d-flex align-center mb-3">
				<b class="mr-3 text-right" style="flex:0 0 160px">{{component.title}} (URL):</b>
				<k-icon class="mr-2" color="black">fa-fw {{component.icon}}</k-icon>
				<div style="flex:0 0 700px">
					<k-text-field background-color="#fff" hide-details outlined dense
						style="font-size:14px"
						label=""
						v-model="collection_plan.cpc_text[key]"
					></k-text-field>
				</div>
			</div>
		</div>
	</div>
</div></template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	components: { },
	mixins: [],
	props: {
		plan_type: { type: String, required: true },
		// parent_description: { type: String, required: true },
		editor_collection_plan: { type: Object, required: true },
	},
	data() { return {
		collection_plan: new Collection_Plan(structuredClone(this.editor_collection_plan)),
	}},
	computed: {
		...mapState(['user_info', 'frameworks_loaded', 'framework_records', 'all_courses_loaded', 'all_courses', 'user_info', 'site_config']),
		...mapGetters([]),
		type_noun() {
			if (this.plan_type == 'unit') return 'Unit'
			if (this.plan_type == 'course') return 'Course'
			return '???'	// shouldn't happen
		},

		collection_plan_schemes() {
			let arr = []
			// if we have any collection_plan_schemes of this plan_type from config.php, start with them
			if (this.site_config.collection_plan_schemes.length > 0) {
				for (let cps of this.site_config.collection_plan_schemes) {
					if (cps.cp_scheme_id.includes('_' + this.plan_type)) {
						arr.push(object_copy(cps))
					}
				}
			}
			// add default
			arr.push(Collection_Plan[`default_cp_${this.plan_type}_scheme`]())
			return arr
		},
		collection_plan_schemes_select_arr() {
			let arr = []
			arr.push({value: '', text: `NONE (don’t use ${this.type_noun} Plan for this ${this.plan_type})`})
			for (let cps of this.collection_plan_schemes) {
				arr.push({value: cps.cp_scheme_id, text: cps.label})
			}
			return arr
		},
		collection_plan_select_value: {
			get() {
				if (empty(this.collection_plan)) return ''
				return this.collection_plan.cp_scheme_id
			},
			set(val) {
				this.collection_plan.cp_scheme_id = val
				// if a different plan is selected, we have to initiate the object
				if (!empty(val)) {
					this.collection_plan = new Collection_Plan(this.collection_plan)
					// this.collection_plan.transfer_description_if_necessary(this.parent_description)
				}
			}
		},
	},
	watch: {
		editor_collection_plan: {deep:true, handler() {
			if (JSON.stringify(this.editor_collection_plan) != JSON.stringify(this.collection_plan)) {
				this.collection_plan = new Collection_Plan(structuredClone(this.editor_collection_plan))
			}
		}},
		collection_plan: {deep:true, handler() {
			if (JSON.stringify(this.collection_plan) != JSON.stringify(this.editor_collection_plan)) {
				this.$emit('update:editor_collection_plan', new Collection_Plan(structuredClone(this.collection_plan)))			
			}
		}},
	},
	mounted() {
		vapp.collection_plan_edit_component = this
	},
	methods: {
		editor_config(text, inline) {
			return U.get_froala_config({
				placeholderText: text,
				zIndex: 1000,
				// initOnClick: true,
				// toolbarInline: (inline === true),
				paragraphFormat: {
					// H3: 'Section Header',
					N: 'Normal',
					BLOCKQUOTE: 'Block Quote',
				    PRE: 'Code',
				},
			})
		},

	}
}
</script>

<style lang="scss">
.k-collection-plan-edit {
	background-color:$v-pink-lighten-5;
	border:1px solid $v-pink-darken-4;
	border-radius:6px;
	padding:8px;
}
.k-collection-plan-edit-options {
	padding-left:16px;
	padding-top:12px;
	margin-left:12px;
	border-left:3px solid $v-pink-darken-4;
	font-size:14px;
	line-height:17px
}
</style>
